export default "__VITE_ASSET__j$XBOlpe__"